export default __webpack_public_path__ + "static/media/checkdraw.7a3fdb04.PNG";